import React from "react";
import { TextField } from "@material-ui/core";

const MylocTextField = props => {
  return <TextField margin="normal" variant="outlined" {...props} />;
};

export default MylocTextField;
